import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './style/AdminLogin.css';

const SESSION_TIMEOUT = 10 * 60 * 1000; // 5 минут


function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const isAuth = localStorage.getItem('adminAuth');
        const loginTime = localStorage.getItem('loginTime');

        if (isAuth && loginTime) {
            const diff = Date.now() - Number(loginTime);
            if (diff > SESSION_TIMEOUT) {
                // сессия истекла
                // меньше 5 минут
                navigate('/panel/admin-panel');
            } else {
                // сессия истекла
                localStorage.removeItem('adminAuth');
                localStorage.removeItem('loginTime');
                alert('Сессия истекла, пожалуйста, войдите заново.');
            }
        }
    }, [navigate]);

    const handleLogin = (e) => {
        e.preventDefault();

        if (username === 'admin' && password === '1234') {
            localStorage.setItem('adminAuth', 'true');
            localStorage.setItem('loginTime', Date.now().toString()); // сохраняем время входа
            navigate('/panel/admin-panel');
        } else {
            setError('Неверное имя пользователя или пароль');
        }
    };

    return (
        <div className="admin-login-page">
            <div className="login-box">
                <h2>Вход в админ-панель</h2>
                <form onSubmit={handleLogin}>
                    <label>Имя пользователя</label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />

                    <label>Пароль</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    {error && <p className="error">{error}</p>}

                    <button type="submit">Войти</button>
                </form>
            </div>
        </div>
    );
}

export default AdminLogin;
